if (!customElements.get("video-marquee")) {
	class VideoMarquee extends HTMLElement {
		constructor() {
			super();
			this.swiper = null;
			this.swiperContainer = null;
		}

		connectedCallback() {
			this.addEventListener("youtube:state:change", (e) => this.handleVideoStateChange(e));
			this.initializeSwiper();
		}

		handleVideoStateChange(event) {
			const { state, videoElement } = event.detail;
			const shouldPause = state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING;

			if (shouldPause) {
				this.swiper.autoplay.stop();
			} else {
				this.swiper.autoplay.start();
			}

			if (state === YT.PlayerState.PLAYING) {
				const currentlyPlaying = this.querySelector("youtube-video.is-playing");
				if (currentlyPlaying && currentlyPlaying !== videoElement) {
					currentlyPlaying.player.pauseVideo();
					currentlyPlaying.classList.remove("is-playing");
				}
				videoElement.classList.add("is-playing");
			} else if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
				videoElement.classList.remove("is-playing");
			}
		}

		initializeSwiper() {
			this.swiperContainer = this.querySelector("swiper-container.video-marquee-swiper");
			if (!this.swiperContainer) return;

			const scrollbarEl = this.querySelector(".video-marquee-swiper-scrollbar");
			const prevBtn = this.querySelector(".swiper-button-prev");
			const nextBtn = this.querySelector(".swiper-button-next");
			const speed = parseInt(this.swiperContainer.dataset.autoplaySpeed) || 5000;
			const delay = parseInt(this.swiperContainer.dataset.autoplayDelay) || 5000;

		const swiperParams = {
			slidesPerView: "auto",
			spaceBetween: parseInt(this.dataset?.mobileGap) || 8,
			allowTouchMove: true,
			injectStyles: [],
			autoplay: {
				speed,
				delay,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			breakpoints: {
				749: {
					spaceBetween: parseInt(this.dataset?.gap) || 8,
				},
			},
			on: {
				init: (swiper) => {
					this.swiper = swiper;
					this.swiperContainer.setAttribute("data-initialized", "true");
				}
			},
		};

			if (prevBtn && nextBtn) {
				swiperParams.navigation = {
					nextEl: nextBtn,
					prevEl: prevBtn,
				};
			}

			if (scrollbarEl) {
				swiperParams.scrollbar = {
					el: scrollbarEl,
					draggable: true,
				};
			}

			Object.assign(this.swiperContainer, swiperParams);
			this.swiperContainer.initialize();
		}
	}
	customElements.define("video-marquee", VideoMarquee);
}
